import React from 'react';
import { useTranslation } from 'react-i18next';

import { Default } from '../../../layouts';
import PageTitle from '../../../components/PageTitle';
import InternalCorrectionGrid from './InternalCorrectionGrid';

const InternalCorrection = () => {
  const { t } = useTranslation();

  return (
    <Default>
      <PageTitle title={t('pages.support.internalCorrection._')} />
      <InternalCorrectionGrid />
    </Default>
  );
};

export default InternalCorrection;
